module.exports = __webpack_public_path__ + "img/person_fengliang.4c5f463f.jpg";